module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_promo_registration_error", [["div",{"class":"dlg-content"},[["div",{"class":"popup-content"},[["div",{"class":"result-message error"},[["p",{},[["textNode",{"text":"Sorry, something went wrong during your registration process, please try to re-submit registration form or contact our "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"Customer Support"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!../promo/templates/popup/registrationError.tpl
// module id = 533
// module chunks = 2